import { motion } from "framer-motion";
import { Sprout, Wheat, FlaskConical } from "lucide-react";

const PROBIOTICS_IMG = "https://images.unsplash.com/photo-1571212515416-fef01fc43637?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxwcm9iaW90aWNzJTIweW9ndXJ0JTIwZmVybWVudGVkJTIwZm9vZCUyMGd1dCUyMGhlYWx0aHxlbnwwfHx8fDE3ODkyMjQyMTd8MA&ixlib=rb-4.1.0&q=85";

const FEATURES = [
  { icon: Sprout, title: "Fermentierte Lebensmittel", text: "Kefir, Kimchi, Sauerkraut & Nattō liefern lebende Kulturen und Vitamin K2 – natürliche Verbündete für die Knochenmatrix." },
  { icon: Wheat, title: "Präbiotische Ballaststoffe", text: "Inulin, Topinambur und Artischocken füttern nützliche Darmbakterien, die kurzkettige Fettsäuren (SCFA) bilden." },
  { icon: FlaskConical, title: "Entzündungshemmende Naturstoffe", text: "Omega-3, Polyphenole und Curcumin senken stille Entzündungen, die den Knochenabbau beschleunigen." },
];

export default function Probiotics() {
  return (
    <section id="probiotika" className="scroll-mt-24 py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative order-2 lg:order-1"
        >
          <div className="rounded-3xl overflow-hidden shadow-xl ring-1 ring-[#E2DDD3]">
            <img src={PROBIOTICS_IMG} alt="Probiotische fermentierte Lebensmittel" className="w-full h-[420px] object-cover" />
          </div>
          <div className="absolute -top-5 -right-4 bg-[#1E3F20] text-white rounded-2xl shadow-xl px-5 py-4 hidden sm:block">
            <p className="text-xs uppercase tracking-widest text-[#B9C9B7]">Gut-Bone-Axis</p>
            <p className="font-display text-lg font-bold">Darm ↔ Knochen</p>
          </div>
        </motion.div>

        <div className="order-1 lg:order-2">
          <span className="text-xs uppercase tracking-widest font-semibold text-[#C87D55]">Schwerpunkt</span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1C2D24]">
            Probiotika &amp; Naturprodukte
          </h2>
          <p className="mt-4 text-lg text-[#4A5D52] leading-relaxed">
            Die Mikrobiom-Knochen-Achse verbindet einen gesunden Darm mit stabiler Knochendichte. Über kurzkettige
            Fettsäuren, verbesserte Calcium-Aufnahme und weniger Entzündung wirken Probiotika direkt auf den
            Knochenstoffwechsel.
          </p>
          <div className="mt-8 space-y-4">
            {FEATURES.map((f, i) => (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="flex items-start gap-4 bg-white rounded-2xl ring-1 ring-[#E2DDD3] p-5 hover:shadow-md transition-shadow"
              >
                <div className="shrink-0 w-11 h-11 rounded-xl bg-[#E2EBE1] flex items-center justify-center">
                  <f.icon className="w-5 h-5 text-[#2D5A27]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#1C2D24]">{f.title}</h3>
                  <p className="text-sm text-[#4A5D52] leading-relaxed mt-1">{f.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
